export const trackEvent = (event, details = {}) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...details });

  window.dispatchEvent(new CustomEvent('tryouts:analytics', {
    detail: { event, ...details },
  }));
};
